export const ko = {
  app: {
    title: "현장 작업일보",
    subtitle: "현장에서 핸드폰으로 입력하고 자동으로 관리",
  },
  common: {
    save: "저장",
    cancel: "취소",
    edit: "수정",
    delete: "삭제",
    add: "추가",
    manage: "관리",
    status: "상태",
    active: "활성",
    confirmDelete: "정말 삭제할까요?",
    empty: "데이터가 없습니다",
    comingSoon: "준비 중",
    logout: "로그아웃",
  },
  login: {
    title: "현장 작업일보",
    subtitle: "로그인하여 시작하세요",
    username: "아이디",
    password: "비밀번호",
    submit: "로그인",
    submitting: "로그인 중…",
    invalid: "아이디 또는 비밀번호가 올바르지 않습니다",
    errorGeneric: "로그인 중 오류가 발생했습니다",
    demoTitle: "샘플 계정",
    demoHint: "탭하면 자동 입력",
    demoRoleAdmin: "관리자",
    demoRoleOperator: "현장 작업자",
  },
  home: {
    greeting: "{{name}}님, 안녕하세요",
    subtitle: "오늘 작업을 시작하세요",
    action: {
      newReport: "오늘 일보 입력",
      list: "일보 조회",
      admin: "관리자 메뉴",
    },
  },
  admin: {
    tab: {
      dashboard: "대시보드",
      equipment: "설비",
      processes: "공정",
      specs: "검사규격",
      tools: "공구",
      categories: "카테고리",
      users: "사용자",
    },
    equipment: {
      title: "설비 관리",
      equipmentNo: "설비번호",
      name: "설비명",
      machineType: "장비종류",
      add: "설비 추가",
      edit: "설비 수정",
      qr: "QR 코드",
      qrPrint: "인쇄",
      qrHint: "스캔하여 작업일보 입력을 시작합니다",
    },
    process: {
      title: "공정 관리",
      allEquipment: "전체 설비",
      equipment: "설비",
      processName: "공정명",
      carModel: "차종",
      partNo: "품번",
      partName: "품명",
      add: "공정 추가",
      edit: "공정 수정",
    },
    spec: {
      title: "검사 규격",
      allProcess: "공정 선택",
      kind: "구분",
      specText: "규격",
      period: "주기",
      nominal: "기준",
      add: "규격 추가",
      edit: "규격 수정",
    },
    tool: {
      title: "공구 관리",
      toolSpec: "공구 규격",
      lifetime: "수명",
      add: "공구 추가",
      edit: "공구 수정",
    },
    category: {
      title: "카테고리 관리",
      downtime: "비가동 사유",
      defect: "불량 유형",
      name: "이름",
      add: "카테고리 추가",
      edit: "카테고리 수정",
    },
    user: {
      title: "사용자 관리",
      username: "아이디",
      name: "이름",
      role: "권한",
      lang: "언어",
      password: "비밀번호",
      passwordReset: "비밀번호 재설정 (선택)",
      usernameRule: "영문 소문자로 시작하는 4~20자 영숫자",
      add: "사용자 추가",
      edit: "사용자 수정",
      roleValue: {
        admin: "관리자",
        manager: "매니저",
        operator: "작업자",
      },
    },
  },
  reports: {
    save: "저장",
    saved: "저장됨",
    saveError: "저장 중 오류가 발생했습니다",
    new: {
      title: "새 일보 작성",
      equipment: "설비",
      equipmentPick: "설비를 선택하세요",
      date: "작업일자",
      start: "입력 시작",
    },
    list: {
      title: "일보 조회",
      date: "작업일자",
      equipment: "설비",
      allEquipment: "전체 설비",
      from: "시작일",
      to: "종료일",
      producedDay: "주간 (생산/목표)",
      producedNight: "야간 (생산/목표)",
      download: "엑셀 다운로드",
    },
    tab: {
      header: "기본정보",
      inspect: "자주검사",
      defect: "불량",
      downtime: "비가동",
      tools: "공구",
      log: "이상/특이",
      photos: "사진",
    },
    photos: {
      add: "사진 추가",
      caption: "설명 (선택)",
      saveFirst: "사진을 추가하려면 먼저 일보를 저장하세요.",
    },
    field: {
      process: "공정",
      targetDay: "주간 목표",
      targetNight: "야간 목표",
      producedDay: "주간 생산",
      producedNight: "야간 생산",
      heatNo: "HEAT No.",
      defectKind: "불량유형",
      downtimeKind: "비가동 사유",
    },
    toolMark: {
      clear: "지우기",
    },
    log: {
      anomalies: "이상발생 내역",
      issues: "특이사항 / 조치",
      occurTime: "발생 시간",
      deviation: "이상 내용",
      afterToolChange: "공구교환 후 조치",
      note: "비고",
      occurrence: "발생 내용",
      action: "조치 내용",
    },
    slot: {
      dayStart: "주초",
      dayMid: "주중",
      dayEnd: "주종",
      nightStart: "야초",
      nightMid: "야중",
      nightEnd: "야종",
    },
    kind: {
      appearance: "외관",
      dimension: "치수",
    },
    shift: {
      day: "주간",
      night: "야간",
    },
    note: {
      minutes: "단위: 분",
    },
  },
  dashboard: {
    range: {
      today: "오늘",
      week: "최근 7일",
      month: "최근 30일",
    },
    stat: {
      reports: "일보 건수",
      achievement: "달성율",
      defectRate: "불량률",
      downtime: "비가동",
    },
    outOfSpec: {
      title: "규격 이탈 {{count}}건",
      spec: "규격",
      slot: "시점",
      value: "측정값",
    },
    panel: {
      byDate: "일자별 추이",
      byDowntime: "비가동 사유 (분)",
      byDefect: "불량 사유 (수량)",
    },
  },
  health: {
    status: "API 상태",
    checking: "확인 중…",
  },
} as const;
